import type { CSSProperties, ReactElement } from 'react';

interface AvatarProps {
  email: string;
  size?: 'sm' | 'md' | 'lg';
}

const SIZE_PX: Record<NonNullable<AvatarProps['size']>, number> = {
  sm: 20,
  md: 28,
  lg: 40,
};

/**
 * Avatar v4: gradiente warm terracotta + initials del email.
 * El gradiente y el color de texto son los mismos que el `.avatar` del
 * topbar — definido en tokens.css `.avatar` — pero acá podemos
 * controlar el tamaño.
 */
export function Avatar({ email, size = 'md' }: AvatarProps): ReactElement {
  const px = SIZE_PX[size];
  const initials = (email || '?').slice(0, 2).toUpperCase();
  const style: CSSProperties = {
    width: px,
    height: px,
    borderRadius: '50%',
    background:
      'radial-gradient(circle at 38% 35%, #fff8ee 0%, #f6a266 45%, #c75e22 95%)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: Math.max(9, Math.round(px * 0.42)),
    fontWeight: 600,
    color: 'oklch(18% 0.04 40)',
    flexShrink: 0,
    boxShadow: 'inset 0 -1px 1px oklch(40% 0.18 30 / 0.4)',
  };
  return (
    <span aria-hidden="true" style={style}>
      {initials}
    </span>
  );
}
